import { useQuery } from '@tanstack/react-query';

import { MeResponse } from '@raven/shared-types';
import { api } from './api.js';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get('/api/auth/me', MeResponse),
    staleTime: 60_000,
    retry: false,
  });
}
